"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _core = require("@stt-componentes/core");
var _buscaFormik = _interopRequireDefault(require("./buscaFormik"));
var _grid = _interopRequireDefault(require("../grid"));
var _fieldNames = require("../fieldNames");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FormFormik = function FormFormik(_ref) {
  var strings = _ref.strings,
    _ref$obrigatorio = _ref.obrigatorio,
    obrigatorio = _ref$obrigatorio === void 0 ? false : _ref$obrigatorio,
    formExterno = _ref.formExterno,
    _ref$multiplos = _ref.multiplos,
    multiplos = _ref$multiplos === void 0 ? false : _ref$multiplos;
  var _formExterno$decs = formExterno.decs,
    decs = _formExterno$decs === void 0 ? [] : _formExterno$decs,
    errors = formExterno.errors,
    isSubmitting = formExterno.isSubmitting,
    submitCount = formExterno.submitCount,
    setFieldValue = formExterno.setFieldValue;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClick = function handleClick() {
    setOpen(!open);
  };
  var secaoDecs = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (isSubmitting) {
      return;
    }
    if (obrigatorio && errors !== null && errors !== void 0 && errors[_fieldNames.FIELDS.DECS]) {
      setTimeout(function () {
        secaoDecs.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start"
        });
      }, 50);
    }
  }, [isSubmitting, obrigatorio]);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    onSubmit: function onSubmit(values) {
      setFieldValue(_fieldNames.FIELDS.DECS, values.decs);
    },
    initialValues: {
      decs: decs
    }
  }, function (_ref2) {
    var values = _ref2.values;
    return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: _fieldNames.FIELDS.DECS,
      render: function render(_ref3) {
        var _values$FIELDS$DECS;
        var push = _ref3.push,
          remove = _ref3.remove;
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          container: true,
          spacing: 3
        }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement(_core.SttHeading, {
          variant: "h4",
          color: "primary"
        }, strings.tituloDecs), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
          size: "small"
        }, strings.descricaoDecs))), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          container: true,
          spacing: 3
        }, (((_values$FIELDS$DECS = values[_fieldNames.FIELDS.DECS]) === null || _values$FIELDS$DECS === void 0 ? void 0 : _values$FIELDS$DECS.length) === 0 || multiplos) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement(_core.SttButton, {
          variant: "contained",
          color: "secondary",
          nomarginleft: "true",
          onClick: handleClick
        }, "".concat(strings.adicionar, " ").concat(strings.decs)), obrigatorio && (errors === null || errors === void 0 ? void 0 : errors[_fieldNames.FIELDS.DECS]) && submitCount > 0 && /*#__PURE__*/_react["default"].createElement(_core.SttFormHelperText, {
          error: true
        }, strings.campoObrigatorio)), /*#__PURE__*/_react["default"].createElement(_buscaFormik["default"], {
          strings: strings,
          open: open,
          setOpen: setOpen,
          handleAdd: push,
          multiplos: multiplos
        })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/_react["default"].createElement("div", {
          ref: secaoDecs
        }, /*#__PURE__*/_react["default"].createElement(_grid["default"], {
          strings: strings,
          decs: values[_fieldNames.FIELDS.DECS],
          handleDelete: function handleDelete(index) {
            remove(index);
            setFieldValue(_fieldNames.FIELDS.DECS, values[_fieldNames.FIELDS.DECS].filter(function (_, i) {
              return i !== index;
            }));
          }
        })))));
      }
    });
  });
};
var _default = exports["default"] = FormFormik;